export const getItemType = (bankId: number, accountId: null | number, selectedBankId?: number) => {
    if (bankId === Number(accountId) && bankId === Number(selectedBankId)) {
        return 'usedAndSelected'
    }
    if (bankId === Number(accountId)) {
        return 'used'
    }
    if (bankId === Number(selectedBankId)) {
        return 'selected'
    }

    return 'default'
}
